const state={
  pcCount:0,
  menuBackground: '#ffffff'
};

// 类似于sate属性的computed用法
const getters={
  doubleCount(){
    return state.pcCount * 2
  }
};

// 具体操作state中属性的方法
const mutations={
  changeCountMutation(state,val){
    state.pcCount = val
  },
  changeMenuBackgroundMutation(state,val){
    // console.log(val)
    state.menuBackground = val
  },
};

// 正规情况下往外暴露的方法，内部调用mutation中的方法
const actions={
  changeCountAction(context,val){
    context.commit('changeCountMutation',val)
  },
  changeMenuBackgroundAction(context,val){
    context.commit('changeMenuBackgroundMutation',val)
  },
};

export default {
  namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
  state,
  getters,
  mutations,
  actions
}
